import $ from 'jQuery';

export default function () {
    $(function() {
        // Select all expand icons from this block
        var icons = document.querySelectorAll('.fullwidth-links-lists--column-heading .icon');

        // Iterate over each element
        icons.forEach(function(icon) {
            // Add an event listener for the 'click' event
            icon.addEventListener('click', function() {
                // Toggle the 'expanded' class on the parent element of the clicked element
                this.parentElement.classList.toggle('expanded');

                // Find the closest div that matches the selector '.block--fullwidth-links-lists'. This is needed in case there are many blocks of this type, we just want to expand/collapse this one
                var ancestor = $(this).closest('.fullwidth-links-lists--column');

                // If the div exists, find the div with the class 'content'
                if (ancestor.length) {
                    var columnsDiv = ancestor.find('.content');

                    // If the div exists, toggle its display property between 'block' and 'none'
                    if (columnsDiv.length) {
                        columnsDiv.slideToggle();
                        if (columnsDiv.css('display') != 'none') {
                            columnsDiv.css('display', 'block');
                        }
                    }
                }
            });
        });

        $(window).on('resize', function() {
            if ($(window).width() > 900) {
                $('.fullwidth-links-lists--column h3').removeClass('expanded');
                $('.fullwidth-links-lists--column .content').css('display', 'block');
            }
        });
    });
}
